import React from "react";
import "../assets/styles/About.scss";

const STATS = [
  { num: "10+", label: "tamamlanmış layihə" },
  { num: "15+", label: "komanda təcrübəsi" },
  { num: "5", label: "şirkət" },
];

const LANGS = [
  { name: "Azərbaycan", level: "ana dil", native: true },
  { name: "Türk", level: "C1", native: false },
  { name: "İngilis", level: "B2", native: false },
  { name: "Rus", level: "A2", native: false },
  { name: "Alman", level: "A2", native: false },
];

function About() {
  return (
    <section id="about" className="about">
      <div className="sec-head" data-reveal>
        <span className="sec-num" aria-hidden="true">
          01
        </span>
        <h2 className="sec-title">Developerdən Owner-ə</h2>
      </div>

      <div className="about-body">
        <div className="about-main" data-reveal>
          <p className="about-p">
            Backend Developer kimi başlayıb, bu gün{" "}
            <strong className="ac">Product Owner</strong>,{" "}
            <strong className="ac">IT Layihə Meneceri</strong> və{" "}
            <strong className="ac">Biznes Analitik</strong> kimi fəaliyyət
            göstərirəm. Texniki baza və idarəetmə bacarığı birləşəndə əsl nəticə
            ortaya çıxır.
          </p>
          <p className="about-p muted">
            5 şirkətdə, 10-dan çox layihədə komanda qurmaq, prioritet müəyyən
            etmək və məhsulu bazara çıxarmaqla məşğul olmuşam. Hazırda{" "}
            <strong className="tx">CES</strong>-də Head of Product,{" "}
            <strong className="tx">Martech</strong>-də IT Project Manager kimi
            çalışıram, eyni zamanda öz startapım{" "}
            <strong className="tx">Voint</strong>-i inkişaf etdirirəm.
          </p>

          <div className="about-stats">
            {STATS.map((s) => (
              <div className="stat" key={s.label}>
                <div className="stat-num">{s.num}</div>
                <div className="stat-lbl">{s.label}</div>
              </div>
            ))}
          </div>

          <a href="#contact" className="about-open">
            <span>
              Müsahibəyə açığam <span className="arrow">→</span>
            </span>
          </a>
        </div>

        <div className="about-side">
          <div className="side-block" data-reveal>
            <h3>Dillər</h3>
            <div className="lang-list">
              {LANGS.map((l) => (
                <div className="lang-row" key={l.name}>
                  <span>{l.name}</span>
                  <span className="lang-dots" />
                  <span className={`lang-lvl ${l.native ? "ac" : ""}`}>
                    {l.level}
                  </span>
                </div>
              ))}
            </div>
          </div>

          <div className="side-block" data-reveal>
            <h3>Alətlər və metodlar</h3>
            <p className="tools">
              Jira, Trello, Confluence, Notion, Miro, Figma, Scrum, Kanban,
              Agile, Product Backlog, Sprint Planning, Risk Management,
              Stakeholder Management, KPI
            </p>
            <p className="tools muted">
              <span className="ac">Texniki:</span> Java, Spring Boot, Docker,
              Git, REST API, PostgreSQL, Redis, Swagger, Postman
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}

export default About;
